import './sliding-footer.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSSlidingFooter } from './sliding-footer';

components.register({
	selector: '.gs-SlidingFooter',
	controller: GSSlidingFooter
});
